import request from "@/utils/request";

// 列表(主数据列表)
export function loadRetailMonitoringProductDataRangeListDataApi(data) {
    return request({
      url: "web/retailMonitoringProductDataRange/listData",
      method: "post",
      data
    });
  }
  // 导出
  export function loadRetailMonitoringProductDataRangeExportDataApi(data) {
    return request({
      url: "web/retailMonitoringProductDataRange/exportData",
      method: "post",
      data
    });
  }
  
  // 保存
  export function saveOrUpdateRetailMonitoringProductDataRangeApi(data) {
    return request({
      url: "web/retailMonitoringProductDataRange/saveOrUpdate",
      method: "post",
      data
    });
  }
  
  // 查看
  export function initRetailMonitoringProductDataRangeApi(data) {
    return request({
      url: "web/retailMonitoringProductDataRange/init",
      method: "post",
      data
    });
  }
  
  